import "./src/style/global.css"

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider

export const onClientEntry = async () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }
}
